import React, { useRef } from "react";
import styled from "styled-components";
import { AppColors } from "../../config/AppColors";
import { AppFonts } from "../../config/AppFonts";

const FormInput = styled.input`
  display: block;
  border-radius: 2rem;
  padding: 1.3em 1em 1.3em 4em;
  width: 100%;
  box-sizing: border-box;
  background-color: ${AppColors.SLGrey};
  border: none;
  font-weight: 700;

  ::placeholder {
    color: ${AppColors.BLACK};
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 360px) {
    padding: 1.3em 1em 1.3em 3em;
  }
`;

function Input({
  placeholder,
  onChange,
  type,
  required,
  name,
  disabled,
  style,
}) {
  return (
    <FormInput
      placeholder={placeholder}
      onChange={onChange}
      type={type}
      required={required}
      name={name}
      disabled={disabled}
      style={style}
    />
  );
}

export default Input;
